function Badge({ label, color }) {
  const bgColor = color === "blue" ? "bg-blue-100 text-blue-800" : "bg-red-100 text-red-800";
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor}`}>
      {label}
    </span>
  );
}

export default Badge;
